import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Button, 
  IconButton, 
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  LinearProgress,
} from '@material-ui/core';

import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  rowIcons: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    //paddingLeft: theme.spacing(8),
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const CarTable = props => {
  const { 
    className, 
    userRole,
    cars, 
    onSetSelectedCars,
    onClickOpenRegister,
    onClickOpenEdit,
    onClickOpenDelete,
    disableEditButton,
    disableDeleteButton,

    onClickOpenUploadDialog,
    onClickOpenDownloadDialog,
    
    openProgress,
    page,
    rowsPerPage,
    item_total,
    onPageChange,
    onRowsPerPageChange,

    ...rest 
  } = props;

  const classes = useStyles();

  const [selectedCars, setSelectedCars] = useState([]);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [page, setPage] = useState(0);

  const handleSelectAll = event => {

    let selectedCars;

    if (event.target.checked) {
      selectedCars = cars.map(car => car.id);
    } else {
      selectedCars = [];
    }

    setSelectedCars(selectedCars);
    onSetSelectedCars(selectedCars);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedCars.indexOf(id);
    let newSelectedCars = [];

    if (selectedIndex === -1) {
      newSelectedCars = newSelectedCars.concat(selectedCars, id);
    } else if (selectedIndex === 0) {
      newSelectedCars = newSelectedCars.concat(selectedCars.slice(1));
    } else if (selectedIndex === selectedCars.length - 1) {
      newSelectedCars = newSelectedCars.concat(selectedCars.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedCars = newSelectedCars.concat(
        selectedCars.slice(0, selectedIndex),
        selectedCars.slice(selectedIndex + 1)
      );
    }

    setSelectedCars(newSelectedCars);
    onSetSelectedCars(newSelectedCars);
  };

  // const handlePageChange = (event, page) => {
  //   setPage(page);
  // };

  // const handleRowsPerPageChange = event => {
  //   setRowsPerPage(event.target.value);
  // };

  useEffect(() => {
    //console.log('componentDidUpdate & companies changed');

    const newSelected = selectedCars.filter(id => {
      const findObj = cars.find(obj => obj.id == id);
      return findObj !== undefined && findObj !== null;
    });

    setSelectedCars(newSelected);
    onSetSelectedCars(newSelected);

  }, [cars]);

  return (
    <div>
      {userRole !== 'user' && (
        <div className={classes.row}>
          <Button
            color="primary"
            variant="contained"
            onClick={ onClickOpenRegister }
          >
            등록
          </Button>

          <Button
            color="primary"
            variant="contained"
            disabled={ disableEditButton }
            onClick={ onClickOpenEdit }
          >
            수정
          </Button>

          <Button
            style={{
              //  borderRadius: 35,
                backgroundColor: disableDeleteButton ? "#DCDBDC" : "#E00000",
                color: disableDeleteButton ? "#A6A6A6":"#FFFFFF"
                // padding: "18px 36px",
                // fontSize: "18px"
              }}
            variant="contained"
            disabled={ disableDeleteButton }
            onClick={ onClickOpenDelete }
          >
            삭제
          </Button>

          <div className={classes.rowIcons}>
            <IconButton
              arai-label="view"
              onClick={onClickOpenUploadDialog}
            >
                <CloudUploadIcon />
            </IconButton>

            <IconButton
              arai-label="view"
              onClick={onClickOpenDownloadDialog}
            >
                <CloudDownloadIcon />
            </IconButton>
          </div>

        </div>
      )}
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            {openProgress && <LinearProgress /> }
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={cars.length > 0 && selectedCars.length === cars.length}
                      color="primary"
                      indeterminate={
                        selectedCars.length > 0 &&
                        selectedCars.length < cars.length
                      }
                      onChange={handleSelectAll}
                    />
                  </TableCell>
                  <TableCell>번호</TableCell>
                  <TableCell>차량번호</TableCell>
                  <TableCell>택시회사명</TableCell>
                  <TableCell>대리점명</TableCell>
                  <TableCell>차종</TableCell>
                  <TableCell>연식</TableCell>
                  <TableCell>디바이스현황</TableCell>
                  <TableCell>시리얼번호</TableCell>
                  <TableCell>디바이스장착일</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {cars.map((car, index) => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={car.id}
                    selected={selectedCars.indexOf(car.id) !== -1}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedCars.indexOf(car.id) !== -1}
                        color="primary"
                        onChange={event => handleSelectOne(event, car.id)}
                        value="true"
                      />
                    </TableCell>
                    <TableCell>{index}</TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        {/* <Avatar
                          className={classes.avatar}
                          src={category.avatarUrl}
                        >
                          {getInitials(category.name)}
                        </Avatar> */}
                        <Typography variant="body1">{car.number}</Typography>
                      </div>
                    </TableCell>
                    <TableCell>{car.company}</TableCell>
                    <TableCell>{car.distributor}</TableCell>
                    <TableCell>{car.type}</TableCell>
                    <TableCell>{car.year}</TableCell>
                    <TableCell>{car.device_status}</TableCell>
                    <TableCell>{car.device_serial_no}</TableCell>
                    <TableCell>{car.device_installed_at?moment(car.device_installed_at).format('YYYY-MM-DD'):''}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={classes.actions}>
        <TablePagination
          labelRowsPerPage=''
          component="div"
          count={item_total}
          onChangePage={onPageChange}
          onChangeRowsPerPage={onRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions>
    </Card>

    </div>
  );
};

CarTable.propTypes = {
  className: PropTypes.string,
  cars: PropTypes.array.isRequired,
  onSetSelectedCars: PropTypes.func,
};

CarTable.defaultProps = {
  cars: [],
};

export default CarTable;
